const crops = {
  crops: {
    "1": "Anguria",
    "2": "Zucca estiva",
    "3": "Zucchino",
    "4": "Canna da zucchero",
    "5": "Cetriolo da sottaceto",
    "6": "Melo",
    "7": "Sedano",
    "8": "Albicocco",
    "9": "Sedano verde autunnale",
    "10": "Erba cipollina - primo anno",
    "11": "Erba cipollina - secondo anno",
    "12": "Carota",
    "13": "Patata dolce",
    "14": "Mais (insilato 67% acqua)",
    "15": "Pesco",
    "16": "Patata",
    "17": "Erba cipollina",
    "18": "Aglio",
    "19": "Verza",
    "20": "Fragola",
    "21": "Barbabietola",
    "22": "Broccoli",
    "23": "Cavoletti di Brussels",
    "24": "Sedano - scottato",
    "25": "Barbabietola da zucchero",
    "26": "Carota invernale",
    "27": "Pomodoro",
    "28": "Aglio invernale",
    "29": "Vite (da tavola)",
    "30": "Lattuga - cespo d`estate",
    "31": "Prezzemolo",
    "32": "Lattuga - estiva",
    "33": "Lattuga - ",
    "34": "Topinambur - Carciofo di Gerusalemme",
    "35": "Susino per essicazione",
    "36": "Melone - Cantalupo",
    "37": "Palma da olio",
    "38": "Lattuga",
    "39": "Kiwi",
    "40": "Cavolo rosso",
    "41": "Pero",
    "42": "Banano",
    "43": "Indivia scarola - estate",
    "44": "Indivia scarola - baby leaf",
    "45": "Indivia riccia",
    "46": "Cavolo - conservazione comune",
    "47": "Melone estate",
    "48": "Melone autunno inverno",
    "49": "Fragola - fruttificazione perpetua",
    "50": "Papaya",
    "51": "Spinacio",
    "52": "Pomodoro da Industria",
    "53": "Zucca",
    "54": "Cicoria",
    "55": "Cavolo",
    "56": "Melanzana",
    "57": "Verza primavera",
    "58": "Cavolo verza",
    "59": "Cavolo cappuccio",
    "60": "Fagioli comuni",
    "61": "Arancio",
    "62": "Scalogno rosso",
    "63": "Melone",
    "64": "Tabacco (flue)",
    "65": "Tabacco (burley)",
    "66": "Caffè",
    "67": "Orzo (primavera)",
    "68": "Grano 10% proteine",
    "69": "Grano 12% proteine",
    "70": "Grano 14% proteine",
    "71": "Mais (granella)",
    "72": "Girasole",
    "73": "Riso",
    "74": "Sorgo (granella)",
  },
};
export default crops;
